import React, { useState } from "react";
import { Accordion, OverlayTrigger} from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useParams } from "react-router-dom";
import { TOAST_MESSAGE_CSS, fourPlaceHolder } from "modules/utilities/utility";
import {DashboardOutlined } from "@ant-design/icons";
import { useDiet } from "./store";
import DietPlanQa from "./DietPlanQa";
import { toast } from "react-toastify";
import { Button } from "antd";
import CardDiv from "modules/common/card-div/CardDiv";

function DietPlanCanvas() {
  const [show, setShow] = useState(false);
  const [key, setKey] = useState("dietPlanQ&A");
  const { dietData, dietLoading, fetchDietData } = useDiet();
  const { id } = useParams();
  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => {
    setShow(true);
    fetchDietData(id);
  };

  const handleCopyLink = (text) => {
    if (text?.length > 1) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          toast.success("Link copied successfully", TOAST_MESSAGE_CSS);
        })
        .catch((error) => {
          toast.error("Link copied Failed", TOAST_MESSAGE_CSS);
        });
    } else {
      toast.info("Link is not Available", TOAST_MESSAGE_CSS);
    }
  };

  return (
    <>
      <div variant="primary" className="">
        <div className="d-flex ">
          <OverlayTrigger
            overlay={
              <Tooltip
                style={{ position: "fixed" }}
                id="overlay-trigger-example"
              >
                <div className="fw-bold">Diet Plan</div>
              </Tooltip>
            }
          >
            <div
              className="d-flex text-primary cursor-pointer fs-4 text-black"
              onClick={handleShow}
            >
              <DashboardOutlined />
            </div>
          </OverlayTrigger>
        </div>
      </div>
      <Offcanvas
        show={show}
        onHide={handleClose}
        style={{ width: "45%" }}
        placement="end"
      >
        <Offcanvas.Header
          closeButton
          className="bg-light"
          style={{ zIndex: "999" }}
        >
          <Offcanvas.Title className="mb-n2">
            <div>
              <div className="d-flex gap-5">
                <span
                  className="text-primary fw-bold"
                  style={{ fontFamily: "poppins" }}
                >
                  Diet Plan
                </span>
                <span className="ms-5 text-secondary">
                  All diet questions are filled by user:
                  <span className="text-primary">
                    {" "}
                    {dietData?.isSdpFinished ? "Yes" : "No"}{" "}
                  </span>{" "}
                </span>
                <span>
                  <Button
                    className="float-end mt-n2"
                    type="primary"
                    ghost
                    onClick={() => handleCopyLink(dietData?.dietUrl)}
                  >
                    Copy Diet Plan Link
                  </Button>
                </span>
              </div>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="mt-n3">
          <div>
            {dietLoading ? (
              fourPlaceHolder()
            ) : (
              <CardDiv
                title={<div>Question & Answer</div>}
                component={<DietPlanQa dietData={dietData} />}
              />
            )}
            <div className="mt-5 p-2">
              <CardDiv
                title={<div>Diet Plan FAQ</div>}
                component={dietData?.allQuestionWithAnswer?.map((item) => {
                  return (
                    <Accordion>
                      <Accordion.Item eventKey="1">
                        <Accordion.Header>{item?.id}</Accordion.Header>
                        <Accordion.Body>
                          <div className="my-2 fw-bold text-black">
                            {" "}
                            {item?.subject}
                          </div>
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "1fr 1fr",
                              gap: "1rem",
                            }}
                          >
                            {item?.optionMap?.map((option) => {
                              return (
                                <div className="card p-2">
                                  <div>{option?.value}</div>
                                  <div className="border-bottom"></div>
                                  <div>{option?.name}</div>
                                </div>
                              );
                            })}
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  );
                })}
              />
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default DietPlanCanvas;
